export const creditsTypeIcon = {
  GP: '/assets/images/icons/sms_types/icon-msg-type-deluxe.svg',
  GS: '/assets/images/icons/sms_types/icon-msg-type-standard.svg',
  TI: '/assets/images/icons/sms_types/icon-msg-type-standard.svg',
  SI: '/assets/images/icons/sms_types/icon-msg-type-basic.svg',
  EE: '/assets/images/icons/sms_types/icon-msg-type-international.svg',
  ML: '/assets/images/icons/sms_types/icon-email.svg',
  AD: '/assets/images/icons/sms_types/icon-msg-smsadv.svg'
};

// Flags from https://github.com/hanicker/country-flag-icons
// sintax: ['international acronym','Country name', 'Original country name','svg file name']
// flag: asset/images/icons/flags --> Missing Country are svg file with Upper case.
// column 4 is the requiring registered sender or not
export const nations = [
  ['abw', 'Aruba', 'Aruba', 'aw'],
  ['afg', 'Afghanistan', 'افغانستان', 'af', 'true'],
  ['ago', 'Angola', 'Angola', 'ao'],
  ['alb', 'Albania', 'Shqipëria', 'al'],
  ['and', 'Andorra', 'Andorra', 'ad'],
  ['are', 'United Arab Emirates', 'دولة الإمارات العربية المتحدة', 'ae', 'true'],
  ['arg', 'Argentina', 'Argentina', 'ar'],
  ['arm', 'Armenia', 'Հայաստան', 'am', 'true'],
  ['asm', 'American Samoa', 'American Samoa', 'as'],
  ['aus', 'Australia', 'Australia', 'au', 'true'],
  ['aut', 'Austria', 'Österreich', 'at'],
  ['aze', 'Azerbaijan', 'Azərbaycan', 'az'],
  ['bdi', 'Burundi', 'Burundi', 'bi'],
  ['bel', 'Belgium', 'België', 'be'],
  ['ben', 'Benin', 'Bénin', 'bj'],
  ['bfa', 'Burkina Faso', 'Burkina Faso', 'bf'],
  ['bgd', 'Bangladesh', 'Bangladesh', 'bd'],
  ['bgr', 'Bulgaria', 'България', 'bg', 'true'],
  ['bhr', 'Bahrain', '‏البحرين', 'bh'],
  ['bih', 'Bosnia and Herzegovina', 'Bosna i Hercegovina', 'ba'],
  ['blr', 'Belarus', 'Белару́сь', 'by', 'true'],
  ['blz', 'Belize', 'Belize', 'bz'],
  ['bol', 'Bolivia', 'Bolivia', 'bo'],
  ['bra', 'Brazil', 'Brasil', 'br'],
  ['brn', 'Brunei', 'Negara Brunei Darussalam', 'bn'],
  ['btn', 'Bhutan', 'ʼbrug-yul', 'bt'],
  ['bwa', 'Botswana', 'Botswana', 'bw'],
  ['caf', 'Central African Republic', 'Ködörösêse tî Bêafrîka', 'cf'],
  ['chl', 'Chile', 'Chile', 'cl'],
  ['chn', 'China', '中国', 'cn', 'true'],
  ['civ', 'Ivory Coast', 'Côte d"Ivoire', 'ci'],
  ['cmr', 'Cameroon', 'Cameroon', 'cm'],
  ['cod', 'Democratic Republic of the Congo', 'République démocratique du Congo', 'cd'],
  ['cog', 'Republic of the Congo', 'République du Congo', 'cg'],
  ['cok', 'Cook Islands', 'Cook Islands', 'ck'],
  ['col', 'Colombia', 'Colombia', 'co'],
  ['com', 'Comoros', 'Komori', 'km'],
  ['cpv', 'Cape Verde', 'Cabo Verde', 'cv'],
  ['cri', 'Costa Rica', 'Costa Rica', 'cr', 'true'],
  ['cub', 'Cuba', 'Cuba', 'cu', 'true'],
  ['cyp', 'Cyprus', 'Κύπρος', 'cy'],
  ['cze', 'Czech Republic', 'Česká republika', 'cz', 'true'],
  ['den', 'Denmark', 'Danmark', 'dk'],
  ['deu', 'Germany', 'Deutschland', 'de'],
  ['dji', 'Djibouti', 'Djibouti', 'dj'],
  ['dza', 'Algeria', 'الجزائر', 'dz'],
  ['ecu', 'Ecuador', 'Ecuador', 'ec'],
  ['egy', 'Egypt', 'مصر‎', 'eg', 'true'],
  ['eri', 'Eritrea', 'ኤርትራ', 'er'],
  ['esp', 'Spain', 'España', 'es'],
  ['est', 'Estonia', 'Eesti', 'ee'],
  ['eth', 'Ethiopia', 'ኢትዮጵያ', 'et'],
  ['fin', 'Finland', 'Suomi', 'fi'],
  ['fji', 'Fiji', 'Fiji', 'fj'],
  ['flk', 'Falkland Islands', 'Falkland Islands', 'fk'],
  ['fra', 'France', 'France', 'fr'],
  ['fro', 'Faroe Islands', 'Føroyar', 'fo'],
  ['fsm', 'Micronesia', 'Micronesia', 'fm'],
  ['gab', 'Gabon', 'Gabon', 'ga'],
  ['gbr', 'United Kingdom', 'United Kingdom', 'gb'],
  ['geo', 'Georgia', 'საქართველო', 'ge'],
  ['gha', 'Ghana', 'Ghana', 'gh'],
  ['gib', 'Gibraltar', 'Gibraltar', 'gi'],
  ['gin', 'Guinea', 'Guinée', 'gn'],
  ['glp', 'Guadeloupe', 'Guadeloupe', 'gp'],
  ['gmb', 'Gambia', 'Gambia', 'gm'],
  ['gnb', 'Guinea-Bissau', 'Guiné-Bissau', 'gw'],
  ['gnq', 'Equatorial Guinea', 'Guinea Ecuatorial', 'gq'],
  ['gre', 'Greece', 'Ελλάδα', 'gr'],
  ['grl', 'Greenland', 'Kalaallit Nunaat', 'gl'],
  ['gtm', 'Guatemala', 'Guatemala', 'gt', 'true'],
  ['guf', 'French Guiana', 'Guyane française', 'gf'],
  ['guy', 'Guyana', 'Guyana', 'gy'],
  ['hkg', 'Hong Kong', '香港', 'hk'],
  ['hnd', 'Honduras', 'Honduras', 'hn', 'true'],
  ['hrv', 'Croatia', 'Hrvatska', 'hr'],
  ['hti', 'Haiti', 'Haïti', 'ht', 'true'],
  ['hun', 'Hungary', 'Magyarország', 'hu'],
  ['ind', 'India', 'भारत', 'in'],
  ['ire', 'Ireland', 'Éire', 'ie'],
  ['irn', 'Iran', 'ایران', 'ir', 'true'],
  ['irq', 'Iraq', 'العراق', 'iq', 'true'],
  ['isl', 'Iceland', 'Ísland', 'is'],
  ['isr', 'Israel', 'יִשְׂרָאֵל', 'il', 'true'],
  ['ita', 'Italy', 'Italia', 'it'],
  ['jor', 'Jordan', 'الأردن', 'jo', 'true'],
  ['jpn', 'Japan', '日本', 'jp'],
  ['ken', 'Kenya', 'Kenya', 'ke', 'true'],
  ['kgz', 'Kyrgyzstan', 'Кыргызстан', 'kg'],
  ['khm', 'Cambodia', 'Kâmpŭchéa', 'kh', 'true'],
  ['kir', 'Kiribati', 'Kiribati', 'ki'],
  ['kor', 'South Korea', '대한민국', 'kr'],
  ['kwt', 'Kuwait', 'الكويت', 'kw', 'true'],
  ['lao', 'Laos', 'ສປປລາວ', 'la'],
  ['lbn', 'Lebanon', 'لبنان', 'lb'],
  ['lbr', 'Liberia', 'Liberia', 'lr'],
  ['lby', 'Libya', '‏ليبيا', 'ly', 'true'],
  ['lie', 'Liechtenstein', 'Liechtenstein', 'li'],
  ['lka', 'Sri Lanka', 'śrī laṃkāva', 'lk', 'true'],
  ['lso', 'Lesotho', 'Lesotho', 'ls'],
  ['ltu', 'Lithuania', 'Lietuva', 'lt'],
  ['lux', 'Luxembourg', 'Luxembourg', 'lu'],
  ['lva', 'Latvia', 'Latvija', 'lv'],
  ['mac', 'Macao', '澳門', 'mo'],
  ['mar', 'Morocco', 'المغرب', 'ma', 'true'],
  ['mco', 'Monaco', 'Monaco', 'mc'],
  ['mda', 'Moldova', 'Moldova', 'md'],
  ['mdg', 'Madagascar', 'Madagasikara', 'mg'],
  ['mdv', 'Maldives', 'Maldives', 'mv'],
  ['mex', 'Mexico', 'México', 'mx'],
  ['mhl', 'Marshall Islands', 'M̧ajeļ', 'mh'],
  ['mkd', 'Macedonia', 'Македонија', 'mk'],
  ['mli', 'Mali', 'Mali', 'ml'],
  ['mlt', 'Malta', 'Malta', 'mt'],
  ['mmr', 'Myanmar [Burma]', 'မြန်မာ', 'mm'],
  ['mne', 'Montenegro', 'Црна Гора', 'me'],
  ['mng', 'Mongolia', 'Монгол улс', 'mn'],
  ['moz', 'Mozambique', 'Moçambique', 'mz', 'true'],
  ['mrt', 'Mauritania', 'موريتانيا', 'mr'],
  ['mtq', 'Martinique', 'Martinique', 'mq'],
  ['mus', 'Mauritius', 'Maurice', 'mu', 'true'],
  ['mwi', 'Malawi', 'Malawi', 'mw'],
  ['mys', 'Malaysia', 'Malaysia', 'my'],
  ['myt', 'Mayotte', 'Mayotte', 'yt'],
  ['nam', 'Namibia', 'Namibia', 'na'],
  ['ncl', 'New Caledonia', 'Nouvelle-Calédonie', 'nc'],
  ['ned', 'Netherlands', 'Nederland', 'nl'],
  ['ner', 'Niger', 'Niger', 'ne'],
  ['nga', 'Nigeria', 'Nigeria', 'ng', 'true'],
  ['nic', 'Nicaragua', 'Nicaragua', 'ni', 'true'],
  ['niu', 'Niue', 'Niuē', 'nu'],
  ['nor', 'Norway', 'Norge', 'no'],
  ['npl', 'Nepal', 'नपल', 'np'],
  ['nru', 'Nauru', 'Nauru', 'nr'],
  ['nzl', 'New Zealand', 'New Zealand', 'nz'],
  ['omn', 'Oman', 'عمان', 'om', 'true'],
  ['pak', 'Pakistan', 'Pakistan', 'pk', 'true'],
  ['pan', 'Panama', 'Panamá', 'pa', 'true'],
  ['per', 'Peru', 'Perú', 'pe'],
  ['phl', 'Philippines', 'Pilipinas', 'ph', 'true'],
  ['plw', 'Palau', 'Palau', 'pw'],
  ['png', 'Papua New Guinea', 'Papua Niugini', 'pg'],
  ['pol', 'Poland', 'Polska', 'pl', 'true'],
  ['por', 'Portugal', 'Portugal', 'pt'],
  ['prk', 'North Korea', '북한', 'kp'],
  ['pry', 'Paraguay', 'Paraguay', 'py'],
  ['pyf', 'French Polynesia', 'Polynésie française', 'pf'],
  ['qat', 'Qatar', 'قطر', 'qa'],
  ['reu', 'Réunion', 'La Réunion', 're'],
  ['rom', 'Romania', 'România', 'ro', 'true'],
  ['rus', 'Russia', 'Россия', 'ru', 'true'],
  ['rwa', 'Rwanda', 'Rwanda', 'rw'],
  ['sau', 'Saudi Arabia', 'العربية السعودية', 'sa', 'true'],
  ['sdn', 'Sudan', 'السودان', 'sd'],
  ['sen', 'Senegal', 'Sénégal', 'sn'],
  ['sgp', 'Singapore', 'Singapore', 'sg', 'true'],
  ['shn', 'Saint Helena', 'Saint Helena', 'sh'],
  ['slb', 'Solomon Islands', 'Solomon Islands', 'sb'],
  ['sle', 'Sierra Leone', 'Sierra Leone', 'sl'],
  ['slo', 'Slovenia', 'Slovenija', 'si', 'true'],
  ['slv', 'El Salvador', 'El Salvador', 'sv', 'true'],
  ['smr', 'San Marino', 'San Marino', 'sm'],
  ['som', 'Somalia', 'Soomaaliya', 'so', 'true'],
  ['spm', 'Saint Pierre and Miquelon', 'Saint-Pierre-et-Miquelon', 'pm'],
  ['stp', 'São Tomé and Príncipe', 'São Tomé e Príncipe', 'st'],
  ['sui', 'Switzerland', 'Schweiz', 'ch'],
  ['sur', 'Suriname', 'Suriname', 'sr'],
  ['svk', 'Slovakia', 'Slovensko', 'sk', 'true'],
  ['swe', 'Sweden', 'Sverige', 'se'],
  ['swz', 'Swaziland', 'Swaziland', 'sz'],
  ['syc', 'Seychelles', 'Seychelles', 'sc'],
  ['syr', 'Syria', 'سوريا', 'sy', 'true'],
  ['tcd', 'Chad', 'Tchad', 'td', 'true'],
  ['tgo', 'Togo', 'Togo', 'tg'],
  ['tha', 'Thailand', 'ประเทศไทย', 'th', 'true'],
  ['tjk', 'Tajikistan', 'Тоҷикистон', 'tj'],
  ['tkl', 'Tokelau', 'Tokelau', 'tk'],
  ['tkm', 'Turkmenistan', 'Türkmenistan', 'tm'],
  ['ton', 'Tonga', 'Tonga', 'to'],
  ['tun', 'Tunisia', 'تونس', 'tn'],
  ['tur', 'Turkey', 'Türkiye', 'tr', 'true'],
  ['tuv', 'Tuvalu', 'Tuvalu', 'tv'],
  ['twn', 'Taiwan', '臺灣', 'tw'],
  ['tza', 'Tanzania', 'Tanzania', 'tz', 'true'],
  ['uga', 'Uganda', 'Uganda', 'ug', 'true'],
  ['ukr', 'Ukraine', 'Україна', 'ua', 'true'],
  ['ury', 'Uruguay', 'Uruguay', 'uy'],
  ['usa', 'United States', 'United States', 'us', 'true'],
  ['uzb', 'Uzbekistan', 'O‘zbekiston', 'uz'],
  ['ven', 'Venezuela', 'Venezuela', 've'],
  ['vnm', 'Vietnam', 'Việt Nam', 'vn', 'true'],
  ['vut', 'Vanuatu', 'Vanuatu', 'vu'],
  ['wlf', 'Wallis and Futuna', 'Wallis et Futuna', 'wf'],
  ['wsm', 'Samoa', 'Samoa', 'ws'],
  ['yem', 'Yemen', 'اليَمَن', 'ye'],
  ['yug', 'Serbia', 'Србија', 'rs', 'true'],
  ['zaf', 'South Africa', 'South Africa', 'za'],
  ['zmb', 'Zambia', 'Zambia', 'zm'],
  ['kaz', 'Kazakhstan', 'Қазақстан Республикасы', 'KZ', 'true'],
  ['idn', 'Indonesia', 'Republik Indonesia', 'ID', 'true'],
  ['can', 'Canada', 'Canada', 'CA', 'true']
];

export const bugsnapApikey = 'dd732bd21100f19c1023619efd97861e';
